import { useEffect, useState } from 'react';
import { Button, Alert } from '../../components/ui';
import { listarServicios } from '../../api/servicios';
import ListaServicios from './ListaServicios';
import './Buscar.css';

export default function PasoServicio({ onElegir, onVolver }) {
  const [servicios, setServicios] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let activo = true;
    (async () => {
      try {
        const data = await listarServicios();
        if (activo) setServicios(data);
      } catch (err) {
        if (activo) setError(err.message);
      } finally {
        if (activo) setCargando(false);
      }
    })();
    return () => { activo = false; };
  }, []);

  return (
    <section aria-labelledby="t1">
      <h2 id="t1">Elegí un servicio</h2>
      <p className="buscar-muted">Estos son los servicios disponibles en el sistema.</p>

      {error && <Alert tone="danger" title="No pudimos cargar los servicios">{error}</Alert>}

      <ListaServicios cargando={cargando} servicios={servicios} onElegir={onElegir} />

      <div className="buscar-actions">
        <Button variant="secondary" onClick={onVolver}>← Volver</Button>
      </div>
    </section>
  );
}